export const GET_ICAL_URL = 'GET_ICAL_URL';
export const SET_ICAL_URL = 'SET_ICAL_URL';
